export default "__VITE_ASSET__CgROQeM4__"